<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Transaction</div>
        <div>
          <bread-crumb :bread-crumbs="['Transaction']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="ps-2">
            <!-- <v-col cols="12" lg="2" sm="6" xs="12">
                  <v-text-field
                    placeholder="Beneficiary Name"
                    outlined
                    :items="transactionList"
                    dense
                    clearable
                    v-model="searchInputs.beneficiary_name"
                  ></v-text-field>
                </v-col> -->
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                placeholder="Pin Number"
                outlined
                :items="transactionList"
                dense
                clearable
                v-model="searchInputs.pin_number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                placeholder="Name"
                outlined
                dense
                clearable
                v-model="searchInputs.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                placeholder="Receiver Name"
                outlined
                dense
                clearable
                v-model="searchInputs.receiverName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-autocomplete
                :items="[
                  { text: 'ALL', value: null },

                  { text: 'Pending', value: 'Pending' },
                  { text: 'Created', value: 'Created' },
                  { text: 'Recieved', value: 'Recieved' },
                  { text: 'Done', value: 'Done' },
                  { text: 'Failed', value: 'Failed' },
                ]"
                placeholder="Transaction status"
                outlined
                dense
                clearable
                v-model="searchInputs.txn_status"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                :items="transactionList"
                v-model="searchInputs.from_date"
                type="date"
                :rules="[validateFromDate]"
                label="From Transaction Date"
                outlined
                dense
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                :items="transactionList"
                v-model="searchInputs.to_date"
                type="date"
                :rules="[validateToDate]"
                label="To Transaction Date"
                outlined
                dense
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12" class="d-flex pb-3">
              <v-btn
                depressed
                class="primary text-capitalize"
                @click="getPayOutSummary()"
                small
                >Get Results</v-btn
              >
              <v-btn
                depressed
                class="mx-2 primary text-capitalize"
                small
                @click="clear()"
                >Clear</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-btn
            depressed
            @click="downloadExcelsheet"
            class="mt-2 ms-1"
            color="primary"
            small
            ><v-icon small>mdi-file-excel-outline</v-icon>Export
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter values."
            hide-details
            dense
            single-line
            clearable
            class="mt-2"
          ></v-text-field
        ></v-row>
      </v-card-text>

      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="transactionList"
        :items-per-page="10"
        :search="search"
        :loading="isLoading"
        @item-expanded="loadDetails"
        loading-text="Loading... Please wait"
        no-data-text="Please select the criteria to view records."
        item-key="id"
        dense
        class="mt-8"
      >
        <template v-slot:item.transaction_pin="{ item }">
          <a
            title="View Transaction Details"
            class="border-d"
            @click="viewPayOut(item)"
            >{{ item.transaction_pin }}</a
          >
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="getColor(item.status)"
            dark
            small
            outlined
            v-if="item.status"
          >
            {{ item.status }}
          </v-chip>
        </template>
        <template v-slot:item.payee_type="{ item }">
          <v-chip color="primary" outlined small>
            {{ item.payee_type }}
          </v-chip>
        </template>
      </v-data-table>
      <v-dialog v-model="openDialog" width="500" persistent>
        <v-card>
          <v-card-title class="text-h5">Request File</v-card-title>
          <v-divider class="p-0 m-0"></v-divider>
          <v-card-text>
            <v-form ref="requestFile">
              <v-checkbox
                v-model="request"
                label="Request file from user."
                disabled
                hide-details
              ></v-checkbox>
              <v-text-field
                label="Remarks"
                v-model="transData.remarks"
                :rules="[(v) => !!v || 'Remarks is required']"
                dense
                outlined
                placeholder="Enter Remarks"
                class="rounded mt-3"
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-divider class="p-0 m-0"></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              outlined
              @click="openDialog = false"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>cancel
            </v-btn>
            <v-btn depressed color="primary" @click="PostRemarks('', true)">
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon>
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <loading
      :active="isloadagents"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import imageViewer from "@/utils/imageViewer.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import PaymentService from "@/services/PaymentService/paymentService.js";
import userService from "@/services/UserService/userService.js";
export default {
  mixins: [alerts],
  name: "Transaction",
  data: () => {
    return {
      headers: [
        { text: "Invoice Id", value: "invoice_id" },
        { text: "Transaction Pin", value: "transaction_pin" },
        { text: "Customer Id", value: "customer_id" },
        { text: "Customer Name", value: "customer_name" },

        { text: "Receiver Name", value: "name" },
        { text: "Amount", value: "amount" },
        { text: "Txn status", value: "status" },

        { text: "Payment Method", value: "payee_type" },
        {
          text: "Payee Id/Account Number",
          value: "account_number",

          align: "center",
        },
        { text: "Address", value: "address" },
        { text: "Email", value: "email" },
        { text: "Mobile", value: "mobile" },

        { text: "Created By", value: "created_by" },

        { text: "Created Date", value: "created_date" },
      ],
      from_date: null,
      to_date: null,
      isActive: null,
      transactionList: [],
      openDialog: false,
      isLoading: false,
      request: true,
      search: "",
      is_suspected: null,
      isImageViewer: false,
      imageViewerUrl: "",
      expanded: [],
      singleExpand: false,
      isloadagents: false,
      searchInputs: {
        to_date: new Date().toJSON().slice(0, 10),
        from_date: new Date().toJSON().slice(0, 10),
        txn_status: null,
      },
      tempCountries: [],
      country: [],
      selectedcoutry: [],

      transData: {
        txn_id: "",
        login_id: "",
        remarks: "",
      },
    };
  },

  components: {
    BreadCrumb,
    imageViewer,

    Loading,
  },
  isActive() {
    return this.searchInputs.beneficiary_name;
  },
  mounted() {
    if (this.$route.query.All_transcations) {
      this.totalTrans();
    }
    if (this.$route.query.Today_transcations) {
      this.searchInputs.txn_status = "Paid";
      this.getTransaction({
        partner_id: this.searchInputs.partner_id,
        txn_status: this.searchInputs.txn_status,
        from_date: this.searchInputs.from_date,
        to_date: this.searchInputs.to_date,
        skip: 0,
        limit: 1000,
      });
    }
    if (this.$route.query.Trans_hold) {
      this.Transhold();
    }
    if (this.$route.query.Trans_cancel) {
      this.TransCancel();
    }
  },
  watch: {
    transactionList(item) {
      console.log(item);
    },
  },
  computed: {},

  methods: {
    getColor(status) {
      if (status == "Paid") return "green";
      else if (status == "Pending") return "orange";
      else if (status == "Recieved") return "yellow";
      else if (status == "Failed") return "red";
      else return "blue";
    },
    viewPayOut(item) {
      this.$router.push({
        name: "Pay-Out-Transaction-Info",
        query: {
          id: item.id,
        },
      });
    },
    async downloadExcelsheet() {
      if (this.transactionList) {
        this.exportToExcel(
          this.headers,
          this.transactionList,
          "transaction_List"
        );
      }
    },
    validateFromDate(value) {
      if (value && this.searchInputs.to_date) {
        return (
          value <= this.searchInputs.to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.searchInputs.from_date) {
        return (
          value >= this.searchInputs.from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },

    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    dialog(data) {
      console.log("data", data);
      this.openDialog = true;
      this.transData.login_id = data.login_id;
      this.transData.txn_id = data.id;
      this.transData.is_suspected = data.is_suspected;
    },
    loadDetails(item) {
      console.log(item);
      console.log(item.item.id);
      this.getTransactionByID(item.item.id, item.item.transaction_id);
    },

    async getPayOutSummary() {
      this.isloadagents = true;
      console.log(this.searchInputs);
      const params = {
        pin_number: this.searchInputs.pin_number,
        name: this.searchInputs.name,
        receiver_name: this.searchInputs.receiverName,
        txn_status: this.searchInputs.txn_status,
        from_date: this.searchInputs.from_date,
        to_date: this.searchInputs.to_date,

        skip: 0,
        limit: 10000,
      };
      try {
        const responseData = await PaymentService.getPayOutSummary(params);
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data.reverse();
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        this.isActive = !this.isActive;
      } catch (e) {
        console.error(e);
        this.isloadagents = false;
      }
    },
    async PostRemarks(data, notify) {
      this.isloadagents = true;
      let paramData = {};
      let authenticate = notify ? this.$refs.requestFile.validate() : true;
      if (notify) {
        paramData = {
          transaction_id: this.transData.txn_id,
          login_id: this.transData.login_id,
          remarks: this.transData.remarks,
          is_notified: true,
        };
      } else {
        paramData = {
          transaction_id: data.id,
          login_id: data.login_id,
          remarks: "",
          is_notified: false,
        };
      }

      if (authenticate) {
        try {
          const responseData = await PaymentService.postRemarks(paramData);
          this.isloadagents = false;
          if (responseData && responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getTransaction();
            this.openDialog = false;
          }
        } catch (e) {
          this.isloadagents = false;
          console.error(e);
        }
      }
    },

    clear() {
      this.searchInputs.beneficiary_name = "";
      this.searchInputs.partner_id = null;
      this.searchInputs.pin_number = "";
      this.searchInputs.txn_status = "";
      this.searchInputs.from_date = null;
      this.searchInputs.to_date = null;
      this.getTransaction();
    },

    // selectCountry() {
    //   this.country = [];
    //   this.tempCountries.forEach((data) => {
    //     this.searchInputs.forEach((country) =>{
    //       if(data.country_name == country){
    //       this.country.push(data)
    //     }
    //     })

    //   })
    //  console.log(this.searchInputs,JSON.stringify( this.country))

    // }

    async getTransactionByID(login_id, transID) {
      const params = {
        skip: 0,
        limit: 100,
      };
      try {
        const responseData = await PaymentService.getTransitionHistory(
          transID,
          login_id,
          params
        );
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionDetails = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTransactionByID(login_id, transID);
        // }
      } catch (e) {
        console.error(e);
      }
    },
    async totalTrans() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalTrans();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.totalTrans();
        // }
        console.log("totalTrans", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async todaysTrans() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTodayTrans();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.todaysTrans();
        // }
        console.log("todaysTrans", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async Transhold() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTransHold();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data[0];
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.Transhold();
        // }
        console.log("Transhold", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async TransCancel() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTransCancel();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data[0];
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.TransCancel();
        // }
        console.log("TransCancel", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
/* .v-messages {
      min-height: 0px !important;
    } */
.v-radio.v-label {
  margin-bottom: 0px !important;
}
.v-input--selection-controls .v-radio > .v-label {
  margin: auto !important;
}
.v-input--selection-controls__input + .v-label {
  margin: auto !important;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
  // border: 1px solid $secondary;
}
.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}
.bord-color {
  // border: 1px solid $secondary;
  border-radius: 10px;
}
table {
  font-family: "Open Sans", sans-serif;
  border: none;
  width: 100%;

  tbody {
    td {
      text-align: left;
      padding: 5px;
      vertical-align: middle;
      font-size: 14px;
      font-weight: normal;
      border: none;
      margin: 5px;
    }
  }
}
</style>
